import Vue from 'vue';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import * as locale from 'dayjs/locale/es'


dayjs.extend(relativeTime);
dayjs.extend(localizedFormat)
dayjs.extend(updateLocale)
dayjs.updateLocale(locale)
// dayjs.updateLocale('es', {
//     months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'), // months Array
//     weekdays: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado_Domingo'.split('_'), // weekdays Array
//     formats: {
//         // abbreviated format options allowing localization
//         LTS: 'h:mm:ss A',
//         LT: 'h:mm A',
//         L: 'MM/DD/YYYY',
//         LL: 'MMMM D, YYYY',
//         LLL: 'MMMM D, YYYY h:mm A',
//         LLLL: 'dddd, MMMM D, YYYY h:mm A',
//         // lowercase/short, optional formats for localization
//         l: 'D/M/YYYY',
//         ll: 'D MMM, YYYY',
//         lll: 'D MMM, YYYY h:mm A',
//         llll: 'DDD, MMMM D, YYYY h:mm A'
//     },
//     relativeTime: {
//         future: "in %s",
//         past: "%s",
//         s: 'a few seconds',
//         m: "a minute",
//         mm: "%d minutes",
//         h: "an hour",
//         hh: "%d hours",
//         d: "a day",
//         dd: "%d días",
//         M: "a month",
//         MM: "%d months",
//         y: "a year",
//         yy: "%d years"
//     }
// })
dayjs.locale('es')
Object.defineProperties(Vue.prototype, {
    $date: {
        get() {
            return dayjs
        }
    }
});